/**
 * @generated SignedSource<<e429e95e14f9c7ce00b2187359df8889>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type magazinesStyleArticleMoreOnThisContentItemContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"entityLink" | "helpersCheckIsMainTopicContent" | "hooksContentItemProvidersContent">;
  readonly " $fragmentType": "magazinesStyleArticleMoreOnThisContentItemContent";
};
export type magazinesStyleArticleMoreOnThisContentItemContent$key = {
  readonly " $data"?: magazinesStyleArticleMoreOnThisContentItemContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"magazinesStyleArticleMoreOnThisContentItemContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "magazinesStyleArticleMoreOnThisContentItemContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "helpersCheckIsMainTopicContent",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Topic",
          "kind": "LinkedField",
          "name": "topics",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "withCoverImage",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "withCoverImageSize768x768",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "withHeadline",
          "value": true
        }
      ],
      "kind": "FragmentSpread",
      "name": "hooksContentItemProvidersContent"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "8dfc76b6cdff7e66636ee33cb4fac9f0";

export default node;
